import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Hamburger from "../../Components/Hamburger/Hamburger";
import Menu from "../Menu/Menu";
import "./Header.scss";
import { ThemeProvider } from "styled-components";
import { theme } from "../../theme";
import { useMediaQuery } from "react-responsive";

const Header = () => {
  const [open, setOpen] = useState(false);
  const menuId = "main-menu";
  const location = useLocation();

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isWalkthroughActive = location.pathname.startsWith("/walkthrough");

  return (
    <nav className={`header ${isMobile ? "mobile" : ""}`}>
      {isMobile ? (
        <ThemeProvider theme={theme}>
          <Hamburger open={open} setOpen={setOpen} aria-controls={menuId} />
          <Menu open={open} setOpen={setOpen} id={menuId} />
        </ThemeProvider>
      ) : (
        <div className="header__buttons-container">
          <NavLink to="/homepage">
            <img
              className="header__logo"
              src="https://conversio.com/wp-content/uploads/2024/06/Conversio_colour_dk@2000x.png.webp"
              alt="Conversio logo"
            />
          </NavLink>
          <NavLink className="header__nav" to="/codesection">
            Code Library
          </NavLink>
          <div className="dropdown">
            <button className={`header__nav ${isWalkthroughActive ? "active" : ""}`}>
              Walkthroughs
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
              </svg>
            </button>
            <div className="dropdown-content">
              <NavLink className="dropdown__item" to="/walkthroughdevs">Dev</NavLink>
              <NavLink className="dropdown__item" to="/walkthroughcros">CRO</NavLink>
            </div>
          </div>
          <NavLink className="header__nav" to="/tracking">Tracking</NavLink>
          <NavLink className="header__nav" to="/quirks">Quirks</NavLink>
        </div>
      )}
    </nav>
  );
};

export default Header;
